import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { isMobile, isAndroid } from "react-device-detect";

import mixpanel from "../../../lib/mixPanel";

import Login from "./Login";
import cache from "memory-cache";

class InviteUser extends Component {
  constructor(props) {
    super(props);
    let mobile;
    let refCode;

    //eslint-disable-next-line
    if (__isBrowser__) {
      if (window.authed) {
        window.location.href = "/";
      }
      refCode = props.match.params.userRefCode;
      mobile = isMobile;
    } else {
      mobile = cache.get("deviceType");
      refCode = props.match.params.userRefCode;
    }
    const redirectUrl = `https://app.adjust.com/2wr4csc?deep_link=locale%3A%2F%2F%3Fuser_ref%3D${refCode}`;
    this.state = {
      signupSection: false,
      mobile,
      refCode,
      redirectUrl
    };
  }
  componentDidMount() {
    const { refCode } = this.state;
    if (refCode) {
      mixpanel.people.set({ "Referred By": refCode, Platform: "Web" });
    }
  }
  handleSignup = () => {
    this.setState({
      signupSection: true
    });
  };
  onCloseSignup = () => {
    this.setState({
      signupSection: false
    });
  };
  render() {
    const { signupSection, refCode, redirectUrl, mobile } = this.state;
    return (
      (signupSection && (
        <Login
          onCloseSection={this.onCloseSignup}
          firstSignup={signupSection}
        />
      )) || (
        <div className="download-mobile-page">
          <div className="head">
            <img src="/svg/logo.svg" />
          </div>
          <div className="white-bg mt-10px body">
            <h5>
              You{"'"}re just one click away from a more rewarding takeaway!
            </h5>
            <img
              src="https://view.adjust.com/impression/xdfedr2"
              border="0"
              width="1"
              height="1"
            />
            <p>
              1.Download the Local E app from the{" "}
              {(isAndroid && "Google Play Store") || "App Store"}.
            </p>
            <p>2.Register your details.</p>
            <p>
              3.Tap {"'"}Promotions{"'"} in the Account tab {"&"} enter{" "}
              <strong>{refCode}</strong>
            </p>
            <p>4.Enjoy</p>
            {redirectUrl && (
              <a
                href={(mobile && redirectUrl) || "javascript: void(0)"}
                target="blank"
                className="btn btn-blue redeem"
              >
                Redeem Now!
              </a>
            )}
            {mobile && (
              <img
                src="https://view.adjust.com/impression/2wr4csc"
                border="0"
                width="1"
                height="1"
              />
            )}
            <p className="description">
              Download our takeaway app now for an even more rewarding
              experience.
            </p>
            <div className="download-icons">
              <a
                href={`https://app.adjust.com/mn8wcjx?deep_link=locale%3A%2F%2F%3Fuser_ref%3D${refCode}`}
                className="ios"
              >
                <img src="/svg/download_app_store.svg" />
              </a>
              <a
                href={`https://app.adjust.com/mn8wcjx?deep_link=locale%3A%2F%2F%3Fuser_ref%3D${refCode}`}
                className="android"
              >
                <img src="/svg/download_google_play.svg" />
              </a>
            </div>
            <img
              src="https://view.adjust.com/impression/mn8wcjx"
              border="0"
              width="1"
              height="1"
              className="desktop-user-ref"
            />
            <a className="continue" href="/">
              Continue to Website
            </a>
          </div>
        </div>
      )
    );
  }
}

export default withRouter(InviteUser);
